import * as types from './mutation-types'

export default {
    [types.SET_LANG] (state, lang) {
       state.lang = lang
    },
    [types.SET_START_TIME] (state, time) {
       state.startTime = time
    },
    [types.SET_END_TIME] (state, time) {
       state.endTime = time
    },
    [types.ADD_CREDIT] (state, num=1) {
       state.credit += num
    }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js